import Vue from 'vue'
import { mapState } from 'vuex'

export const GApiMixin = {
  name: 'GApiMixin',
  computed: {
    ...mapState([
      'isSignedIn',
      'isInitialized',
      'gFilesMap',
      'gFilesMetaMap',
      'gDrivesMap',
      'inProgressFileIds',
      'updateTimeInterval',
      'selectedFolder',
      'googleUser'])
  },
  methods: {
    isCachedAndFresh (id, maxAge, msg) {
      if (maxAge === undefined) maxAge = this.updateTimeInterval
      // if (Object.prototype.hasOwnProperty.call(this.gFilesMap, id)) {
      //   console.log(
      //     'isCachedAndFresh: ', id,
      //     Object.prototype.hasOwnProperty.call(this.gFilesMap, id),
      //     Date.now() - this.gFilesMetaMap[id].lastUpdated, '<=', maxAge,
      //     Date.now() - this.gFilesMetaMap[id].lastUpdated <= maxAge,
      //     msg
      //   )
      // } else {
      //   console.log('isCachedAndFresh: ', id, Object.prototype.hasOwnProperty.call(this.gFilesMap, id), msg)
      // }
      if (maxAge < 0) {
        return Object.prototype.hasOwnProperty.call(this.gFilesMap, id)
      } else {
        return Object.prototype.hasOwnProperty.call(this.gFilesMap, id) && Date.now() - this.gFilesMetaMap[id].lastUpdated <= maxAge
      }
    },
    getBreadcrumbs (fileId, stopAtIds = [], maxAge) {
      return new Promise((resolve, reject) => {
        if (fileId === 'rph-root') {
          const crumbs = { name: 'CombinesBREADCRUMBS' }
          resolve(crumbs)
        } else {
          if (this.isCachedAndFresh(fileId, maxAge, 'getBreadcrumbs')) {
            const hasParents = Object.prototype.hasOwnProperty.call(this.gFilesMap[fileId], 'parents')
            if (hasParents && !stopAtIds.includes(this.gFilesMap[fileId].parents[0])) {
              this.getBreadcrumbs(this.gFilesMap[fileId].parents[0], stopAtIds, maxAge).then((crumbs) => {
                crumbs.push(this.gFilesMap[fileId])
                resolve(crumbs)
              })
            } else {
              resolve([this.gFilesMap[fileId]])
            }
          } else {
            this.getFile(fileId, false, maxAge).then(() => {
              this.getBreadcrumbs(fileId, stopAtIds, maxAge).then(crumbs => {
                resolve(crumbs)
              })
            })
          }
        }
      })
    },
    getFile (id, forceApiCall, maxAge) {
      if (Object.prototype.hasOwnProperty.call(this.inProgressFileIds, id)) {
        return this.inProgressFileIds[id]
      } else {
        const p = new Promise((resolve, reject) => {
          if (forceApiCall || !this.isCachedAndFresh(id, maxAge, 'getFile')) {
            const kind = Object.prototype.hasOwnProperty.call(this.gDrivesMap, id) ? 'drives' : 'files'
            const options = {}
            if (kind === 'drives') {
              options.driveId = id
            } else {
              options.fileId = id
              options.fields = 'id,name,description,kind,mimeType,createdTime,parents,trashed,imageMediaMetadata,videoMediaMetadata,webViewLink,iconLink,owners,driveId'
              // options.fields = '*'
              options.supportsAllDrives = true
              options.includeItemsFromAllDrives = true
              options.enforceSingleParent = true
            }
            // console.log('getFile', kind, options)
            // window.gapi.client.drive.files.get({
            // console.log('getFile api call - ', id)
            window.gapi.client.drive[kind].get(options).then(response => {
              // console.log('getFile.response:', response)
              Vue.delete(this.inProgressFileIds, id)
              // console.log('getFile.response - this.inProgressFileIds.length: ', Object.keys(this.inProgressFileIds).length)
              const file = response.result
              if (file.mimeType === 'application/vnd.google-apps.folder' || file.kind === 'drive#drive') {
                this.$store.commit('addGFile', file)
              }
              resolve(file)
            }).catch(error => {
              Vue.delete(this.inProgressFileIds, id)
              reject(error)
            })
          } else {
            Vue.delete(this.inProgressFileIds, id)
            resolve(this.gFilesMap[id])
          }
        })
        this.inProgressFileIds[id] = p
        // console.log('this.inProgressFileIds.length: ', Object.keys(this.inProgressFileIds).length, this.inProgressFileIds)
        return p
      }
    },
    getFiles (ids, forceApiCall, maxAge) {
      const concat = list => Array.prototype.concat.bind(list)
      const promiseConcat = f => x => f().then(concat(x))
      const promiseReduce = (acc, x) => acc.then(promiseConcat(x))
      const serial = funcs => funcs.reduce(promiseReduce, Promise.resolve([]))// use reduce to loop promise in every element in array in sequence
      // console.log('getFiles called for ', ids.length, ' IDs')
      const funcs = ids.map(id => () => {
        return this.getFile(id, forceApiCall, maxAge)
      })
      return serial(funcs)
    },

    getFilesInParents (folders, isRoot, forceApiCall, next) {
      const driveIds = {}
      let q = ''
      for (let i = 0; i < folders.length; i++) { // loop through all folders
        let oldest = Date.now()
        for (let j = 0; j < this.gFilesMetaMap[folders[i]].children.length; j++) {
          if (Object.prototype.hasOwnProperty.call(this.gFilesMetaMap, this.gFilesMetaMap[folders[i]].children[j])) {
            oldest = Math.min(this.gFilesMetaMap[this.gFilesMetaMap[folders[i]].children[j]].lastUpdated, oldest)
          }
        }
        if (forceApiCall || this.gFilesMetaMap[folders[i]].children.length === 0 || Date.now() - oldest >= this.updateTimeInterval) { // if the api call is not forced
          const driveId = this.gFilesMap[folders[i]].driveId || 'allDrives'
          if (!Object.prototype.hasOwnProperty.call(driveIds, driveId)) driveIds[driveId] = []
          driveIds[driveId].push(folders[i])

          if (q !== '') q += ' or '
          q += '\'' + folders[i] + '\' in parents'
          this.$store.commit('setChildrenStatus', { id: folders[i], status: 'loading' })
        }
      }
      if (Object.keys(driveIds).length > 1) {
        // only allow api call on one drive for efficiency and accuracy
        for (var key of Object.keys(driveIds)) {
          // console.log(key + " -> " + p[key])
          this.getFilesInParents(driveIds[key], isRoot, forceApiCall, next)
        }
        return
      }

      // console.log('----------  getFilesInParents, isRoot:', isRoot, 'forceApiCall:', forceApiCall)
      // console.log('driveIds: ', driveIds)
      // console.log('q:', q)

      if (q !== '') {
        let orderBy = ''
        if (isRoot) {
          if (folders.length && this.gFilesMap[folders[0]].name.search(/review/i) > -1) {
            orderBy = 'folder,name desc,createdTime desc'
          } else {
            orderBy = 'folder,name,createdTime desc'
          }
        } else {
          orderBy = 'folder,createdTime desc,name'
        }
        // console.log('oderBy', orderBy)
        const options = {
          pageSize: 1000,
          q: q + ' and trashed = false',
          fields: 'nextPageToken, incompleteSearch, files(id,name,description,kind,mimeType,createdTime,parents,trashed,imageMediaMetadata,videoMediaMetadata,webViewLink,iconLink,owners,driveId)',
          orderBy: orderBy,
          supportsAllDrives: true
          // includeItemsFromAllDrives: true
          // enforceSingleParent: true
        }
        const driveId = Object.keys(driveIds)[0]
        if (driveId !== 'allDrives') {
          options.corpora = 'drive'
          options.driveId = driveId
          options.includeItemsFromAllDrives = true
        }
        if (next && this.$store.state.apiQueries[q] && this.$store.state.apiQueries[q].nextPageToken) {
          options.pageToken = this.$store.state.apiQueries[q].nextPageToken
        }
        // console.log('getFilesInParents api call, options:', options)
        window.gapi.client.drive.files.list(options).then(response => {
          const files = response.result.files
          // console.log('getFilesInParents', response, folders)
          if (files) {
            const subfolders = []
            for (let i = 0; i < files.length; i++) {
              this.$store.commit('addGFile', files[i]) // add to cache
              if (files[i].mimeType === 'application/vnd.google-apps.folder') {
                subfolders.push(files[i].id)
              }
            }
            const partial = Object.prototype.hasOwnProperty.call(response.result, 'nextPageToken')
            for (let i = 0; i < folders.length; i++) {
              this.$store.commit('setChildrenStatus', { id: folders[i], status: (partial) ? 'partial' : 'complete' })
            }
            if (partial) {
              // this.$store.commit('setChildrenNextPageToken', { id: folders[0], nextPageToken: response.result.nextPageToken })
              this.$store.commit('setApiListQueryMeta', { q: q, nextPageToken: response.result.nextPageToken, folders: folders })
              // this.$state.commit('setNextPageTokenMeta', { nextPageToken: response.result.nextPageToken, value: { parents: folders }}
            }
            if (subfolders.length > 0) {
              this.getFilesInParents(subfolders, false, forceApiCall)
            }
          }
        }).catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
        })
      }
      // console.log('---------- getFilesInParents end')
    }
    // getFilesInParentsNextPage (nextPageToken, folders) {
    //   console.log('getFilesInParentsNextPage', nextPageToken, folders)
    //   window.gapi.client.drive.files.list({
    //     q:
    //     pageSize: 10,
    //     fields: 'nextPageToken, files(id,name,description,mimeType,createdTime,name,parents,trashed,imageMediaMetadata,videoMediaMetadata,webViewLink,iconLink,owners)',
    //     pageToken: nextPageToken
    //   }).then(response => {
    //     const files = response.result.files
    //     if (files) {
    //       console.log('getFilesInParentsNextPage', response, folders)
    //       const subfolders = []
    //       for (let i = 0; i < files.length; i++) {
    //         this.$store.commit('addGFile', files[i]) // add to cache
    //         if (files[i].mimeType === 'application/vnd.google-apps.folder') {
    //           subfolders.push(files[i].id)
    //         }
    //       }
    //       const partial = Object.prototype.hasOwnProperty.call(response.result, 'nextPageToken')
    //       if (!partial) {
    //         for (let i = 0; i < folders.length; i++) {
    //           this.$store.commit('setChildrenStatus', { id: folders[i], status: 'complete' })
    //         }
    //       }
    //       if (subfolders.length > 0) {
    //         this.getFilesInParents(subfolders)
    //       }
    //     }
    //   }).catch(error => {
    //     console.log(error)
    //   })
    // }
  }
}
